import { action, makeObservable } from 'mobx';

import {
  AgentPlatformTokenServer,
  IAgentPlatformToken
} from 'shared/entities/agentPlatform';
import { IRootStore } from 'shared/entities/store/rootStore';
import { apiUrls } from 'shared/entities/domain';
import { LoadingStageModel } from 'shared/models/loadingStage';

export class AgentPlatformTokenModel implements IAgentPlatformToken {
  readonly id: string;
  readonly name: string;
  readonly dateCreated: Date;
  readonly tokenMasked: string;
  readonly removingStage = new LoadingStageModel();
  private rootStore: IRootStore;

  constructor(
    { id, name, dateCreated, tokenMasked }: IAgentPlatformToken,
    rootStore: IRootStore
  ) {
    this.id = id;
    this.name = name;
    this.dateCreated = dateCreated;
    this.tokenMasked = tokenMasked;
    this.rootStore = rootStore;

    makeObservable<AgentPlatformTokenModel>(this, {
      remove: action
    });
  }

  async remove(): Promise<BaseResponse> {
    if (this.removingStage.isLoading) {
      return {
        isError: true
      };
    }

    this.removingStage.loading();

    const response = await this.rootStore.networkStore.api(
      apiUrls.AGENT_PLATFORM_TOKENS_REMOVE,
      {
        method: 'POST',
        data: {
          _id: this.id
        }
      }
    );

    if (response.isError) {
      this.removingStage.error();
    } else {
      this.removingStage.success();
    }

    return {
      isError: response.isError
    };
  }

  static fromJson(
    raw: AgentPlatformTokenServer,
    rootStore: IRootStore
  ): AgentPlatformTokenModel {
    return new AgentPlatformTokenModel(
      {
        id: raw._id,
        name: raw.name,
        dateCreated: new Date(raw.date_created),
        tokenMasked: raw.token_masked
      },
      rootStore
    );
  }
}
